var _defs, _use;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCarouselPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    focusable: "false"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M.72576 17a.73812.73812 0 01-.36288-.09714c-.2247-.13021-.36305-.37093-.36288-.63137V.72986C-.00017.46942.13819.2287.36288.09848a.70893.70893 0 01.72092 0l13.54755 7.77081c.22766.12799.36865.36946.36865.63138 0 .26192-.141.5034-.36865.63138L1.0838 16.90286A.71884.71884 0 01.72576 17z",
    id: "carousel-play_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#carousel-play_svg__a",
    opacity: 0.75,
    transform: "translate(8 5)"
  })));
}

export default __webpack_public_path__ + "ondemand/static/e3056e037/icons/carousel-play.svg";
export { SvgCarouselPlay as ReactComponent };